import React from 'react';
import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

let TableRowEdit = React.createClass({

    getInitialState: function () {
        return {
            LimiteCompra: this.props.row.LimiteCompra
        };
    },

    changeLimit: function (event) {
        this.props.modificacionLimite(parseInt(event.target.value));
    },

    aceptarCambios: function () {
        this.props.aceptarEdicion();
    },

    cancel: function () {
        this.props.cancelEdicionLimite(this.props.row.Id);
    },

    leaveLimite: function () {
        this.props.desaparicionLapizEdicion();
    },

    editLimite: function () {
        this.props.comienzoDeEdicion(this.props.row.Id, this.props.row.LimiteCompra);
    },

    render: function () {

        let limiteCompra = this.props.row.LimiteCompra;

        if (this.props.novedad !== undefined) {
            let valorNovedad = this.props.novedad.ValorNovedad;
            let valorAnterior = this.props.novedad.ValorAnterior;

            if (this.props.novedadEditado != undefined) {
                if (this.props.novedadEditado.edited) {
                    limiteCompra = this.props.novedadEditado.ValorNovedad;
                }
                else {
                    limiteCompra = valorNovedad;
                }
            } else {
                limiteCompra = valorNovedad;
            }
        }

        let buttonNode = null;
        let draw = null;
        if (this.props.editRow == true) {
            draw =
                <div className="col-md-6">
                    <div className="row">
                        <div className="col-md-1">
                            <label className="label-secondary">$</label>
                        </div>
                        <div className="col-md-11 no-padding-left">
                            <div className="row">
                                <div className="col-md-4">
                                <input type="text" className="form-control default-input valid" id={this.props.row.Id} value={limiteCompra}
                                    onChange={this.changeLimit}></input>
                                </div>
                                <div className="col-md-3">
                                    <GenericSimpleButton text="Listo" buttonClass="btn btn-cta" onClick={this.aceptarCambios} />
                                </div>
                                <div className="col-md-5">
                                    <GenericSimpleButton text="Cancelar" buttonClass="btn btn-secondary" onClick={this.cancel} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        } else {
            limiteCompra = GlobalHelper.ConvertirNumeroMilesMillones(limiteCompra);

            draw =
                <div className="col-md-6" onMouseLeave={this.leaveLimite}>
                    <div className="row">
                        <div className="col-md-1 width-0">
                            <label className="label-secondary">$</label>
                        </div>
                        <div className="col-md-4 no-padding-left">
                            <div className="container-distribution">
                                <label className="label-secondary color-azul-claro hand" onClick={this.editLimite}>{limiteCompra}</label>
                                <span onClick={this.editLimite} className="ti-pencil hand" aria-hidden="true"></span>
                            </div>
                            <div className="col-md-7"></div>
                        </div>
                    </div>
                </div>
        }

        return (
            <div className="row">
                <div className="col-md-1">
                </div>
                <div className="col-md-5">
                    <label>{this.props.row.Descripcion} ({this.props.row.TipoDeEmpresa}):</label>
                </div>
                {draw}
            </div>
        );
    }
});

export default TableRowEdit